import { useLoginStore } from '@/stores/loginStore';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

export default function useLogin() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const {
    loginData,
    isLoading,
    error,
    rememberMe,
    updateLoginData,
    setError,
    setRememberMe,
    login,
    resetLoginData,
  } = useLoginStore();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    updateLoginData(name as keyof typeof loginData, value);
  };

  const logout = async () => {
    try {
      // 0. 로그아웃 중임을 표시 (토스트 방지)

      // 1. 데이터 정리 시작
      resetLoginData();

      // 2. 클라이언트 데이터 정리
      queryClient.clear();

      // 3. 로컬 스토리지 정리
      localStorage.removeItem('login-storage');

      // 4. 홈으로 조용히 이동
      navigate('/');

      // 5. 로그아웃 완료 후 플래그 해제
    } catch (error) {
      console.error('로그아웃 중 오류 발생:', error);
      // 오류가 있어도 강제로 로그아웃 처리
      resetLoginData();
      queryClient.clear();
      navigate('/');
    }
  };

  const handleRememberMeChange = (checked: boolean) => {
    setRememberMe(checked);
  };

  const clearError = () => {
    setError(null);
  };

  return {
    loginData,
    isLoading,
    error,
    rememberMe,
    handleInputChange,
    handleRememberMeChange,
    clearError,
    logout,
    login: () => login(navigate),
  };
}
